import { useCallback } from 'react';
export var useSearchProps = function (type, disabled, readOnly, value, inputRef, onChange) {
    var searchProps = {};
    var handleIconClick = useCallback(function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        onChange('');
    }, [inputRef, onChange]);
    if (type === 'search') {
        searchProps.__leftIcon = 'search';
        if (!disabled && !readOnly && value) {
            searchProps.__rightIcon = 'close';
            searchProps.__onRightIconClick = handleIconClick;
        }
    }
    return searchProps;
};
//# sourceMappingURL=use-search-props.js.map